import React, { useState, useEffect } from 'react';
import './Navbar.css';
import { Link } from 'react-router-dom';
import logo from '../../assets/WAY-TRIX.png';

const Navbar = () => {
  const [partnerToken, setPartnerToken] = useState(localStorage.getItem('partnerToken') || '');

  useEffect(() => {
    const interval = setInterval(() => {
      const token = localStorage.getItem('partnerToken') || '';
      if (token !== partnerToken) {
        setPartnerToken(token);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [partnerToken]);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/PartnerLogin" className="navbar-logo">
          <img src={logo} alt="Waytrix Logo" style={{ height: '50px' }} />
        </Link>
        {!partnerToken && (
          <ul className="drawer-menu">
          </ul>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
